// src/pages/xero/XeroCallbackPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseUrl_SPB, hostNameNoWWW, hostNameWithHTTP } from '../../BaseUrl';
import { useAuth } from '../../AuthProvider';

const XeroCallbackPage = () => {
  const navigate = useNavigate();
     const authContext = useAuth();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const codeVerifier = sessionStorage.getItem('xero_code_verifier');
    const redirectUri = `${hostNameWithHTTP}/xero/callback`; // Same as in your PKCE screen

    if (code && codeVerifier) {
      fetch(`${baseUrl_SPB}/api/v1/xero/connect/callback`, {
        method: 'POST',
         headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authContext.token, // Use the token from AuthProvider

      },
        body: JSON.stringify({ code, codeVerifier, redirectUri }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log('✅ Token received:', data);
          sessionStorage.setItem('xero_access_token', data.token.access_token);
          sessionStorage.setItem('tenant_id', data.tenants[0].tenantId);
          // ✅ Redirect to timesheet screen after success
          navigate('/xerodashboard');
        })
        .catch((err) => {
          console.error('❌ Error exchanging code:', err);
        });
    }
  }, [navigate]);

  return <div>Finalizing connection to Xero...</div>;
};

export default XeroCallbackPage;
